import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import Aside from "../../components/Aside";
import Footer from "../../components/Footer";
import Input from "../../components/form-controls/Input";
import TextArea from "../../components/form-controls/TextArea";
import Header from "../../components/Header";
import IfThen from "../../components/IfThen";
import { PaymentsService } from "../../services/PaymentsService";
import { useCurrentAccount } from "../../hooks/useCurrentAccount";
import { AlertService } from "../../services/Alert";
import Button from "../../components/form-controls/Button";
import OpenPayModal from "./OpenPayModal";
import PayPalModal from "./PayPalModal";
import ConektaModal from "./ConektaModal";
import { useTranslation } from "react-i18next";
import useRequest from "../../hooks/useRequest";
import Loader from "../../components/Loader";
import usePermission from "../../hooks/usePermission";
export default function PaymentPage() {

    const { t } = useTranslation();

    const { account } = useCurrentAccount();
    const {call, isRequesting} = useRequest();
    const defaultValues = {
        active_orders_per_cliente: '',
        expire_after_of: '',
        template: '',
    }
    const { register, reset, handleSubmit, formState: { errors, isValid, isSubmitting, submitCount } } = useForm({
        mode: 'onChange',
        defaultValues
    });
    const hasActionAccess = usePermission('payments.actions');
    const [settings, setSettings] = useState(null)
    const [allowPayments, setAllowPayments] = useState(false)
    const [showModalOpenPay, setShowModalOpenPay] = useState(false)
    const [showModalPayPal, setShowModalPayPal] = useState(false)
    const [showModalConekta, setShowModalConekta] = useState(false)

    const getSettings = async () => {
        const { data } = await call(() =>PaymentsService.getSettings(account.id));
        setSettings(data)
    }

    const toggleStatus = async () => {
        const isConfirmed = await AlertService.warning('¡Aviso!', `¿Estás seguro de querer ${settings.is_active ? 'desactivar' : 'activar'} las ordenes de pago?`, async () => {
            try {

                await PaymentsService.toggleStatus(account.id);
                await getSettings()
            } catch (error) {
                console.error(error);
                AlertService.error('¡Error!', 'Ocurrió un error al cambiar el estatus, intenta nuevamente')
            }
        });

        if (isConfirmed) {
            AlertService.toastSuccess('Se cambio el estatus correctamente')
        }
    }

    const saveSettings = async (data) => {
        try {

            data.account_id = account.id;
            await PaymentsService.saveSettings(data)
            await getSettings()

            AlertService.toastSuccess('Se guardó la configuración correctamente')

        } catch (error) {
            console.error(error)
            AlertService.error('¡Error!', 'Ocurrió un error al guardar la configuración, intenta nuevamente')
        }
    }

    const handleCloseModal = async(reload: boolean, cb: Function) => {
        if(reload) {
            await getSettings();
        }
        cb();
    }

    useEffect(() => {
        setAllowPayments(settings?.is_active)

        if (settings) {
            reset({
                active_orders_per_cliente: settings.active_orders_per_cliente,
                expire_after_of: settings.expire_after_of,
                template: settings.template,
            })
        }
    }, [settings])

    useEffect(() => {
        getSettings();
    }, [])

    const heightRequesting = useMemo(()=> {return isRequesting ? 'h-400':''},[isRequesting]);
    return (
        <>
            <Header />
            <Aside />

            <main id="content" role="main" className="main">

                <div className="content container-fluid">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-sm mb-2 mb-sm-0">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb breadcrumb-no-gutter">
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >{t("platform.platform-title")}</span></li>
                                        <li className="breadcrumb-item active" aria-current="page">{t("platform.payments.payments-title")}</li>
                                    </ol>
                                </nav>
                                <h1 className="page-header-title"><i className="bi-credit-card-2-back nav-icon"></i> {t("platform.payments.payments-title")}</h1>
                            </div>
                            <IfThen condition={allowPayments}>
                                <div className="col-sm-auto">
                                    <button className="btn btn-danger" onClick={toggleStatus}><i className="bi-exclamation-circle-fill me-1"></i> {t("platform.payments.enabled.disable")}</button>
                                </div>
                            </IfThen>

                        </div>
                    </div>
                    <div className={`relative ${heightRequesting}`}>
                    {
                        isRequesting ? <Loader/> :
                    <>
                    <IfThen condition={!allowPayments}>
                        <div className="row justify-content-sm-center text-center py-10">
                            <div className="col-sm-7 col-md-5">
                                <img className="img-fluid mb-5" src="/assets/svg/illustrations/oc-add-card.svg" alt="Métodos de pagos" />

                                <h1>{t("platform.payments.payments-disable")}</h1>
                                <p>{t("platform.payments.payments-p")}</p>

                                <button className="btn btn-primary" onClick={() => settings ? toggleStatus() : setAllowPayments(true)} >{t("platform.payments.enable-payments")}</button>
                            </div>
                        </div>
                    </IfThen>

                    <IfThen condition={allowPayments}>
                        {
                            settings && (
                                <div className="row">
                                    <div className="col">
                                        <div className="alert alert-soft-warning" role="alert">
                                            <div className="d-flex">
                                                <img src="/assets/svg/illustrations/oc-megaphone.svg" className="avatar avatar-xl" />
                                                <div className="flex-grow-1 ms-3">
                                                    <h4 className="text-dark">Ambiente de pruebas</h4>
                                                    <p className="text-dark mb-0">Aunque este módulo esta activo, se encuentrá en un ambiente de desarrollo, esto quiere decir que puedes crear enlaces de prueba para validar el flujo del envio.</p>
                                                    <p className="text-dark">Al terminar tu integración, deberás solicitar el cambio de Pruebas a Producción e ingresar las credenciales productivas para comenzar a recibir pagos reales de tus clientes.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }

                        <div className="row">
                            <div className="col-lg-4 mb-3 mb-lg-0">
                                <h4>{t("platform.payments.enabled.config-title")}</h4>
                                <p>{t("platform.payments.enabled.config-p")} </p>
                            </div>
                            <div className="col-lg-8">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row mb-3">
                                            <div className="col-sm-6">
                                                <Input label={t("platform.payments.enabled.number-label")} errors={errors.active_orders_per_cliente} {...register('active_orders_per_cliente', { required: true, pattern: { value: new RegExp(/^[1-9]\d*$/), message: 'Solo se aceptan valores mayores a 0' } })} disabled={hasActionAccess ? false : true}/>
                                            </div>
                                            <div className="col-sm-6">
                                                <Input label={t("platform.payments.enabled.duration-label")}errors={errors.expire_after_of} {...register('expire_after_of', { required: true, pattern: { value: new RegExp(/^[1-9]\d*$/), message: 'Solo se aceptan valores mayores a 0' } })} disabled={hasActionAccess ? false : true}/>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <TextArea label={t("platform.payments.enabled.template-label")} errors={errors.template} {...register('template', { required: true })} disabled={hasActionAccess ? false : true}/>
                                                <span className="form-text">{t("platform.payments.enabled.template-p")}</span>
                                            </div>
                                        </div>

                                        <div className="d-flex justify-content-end gap-3 mt-5">
                                            <Button className="btn btn-primary" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(saveSettings)}>{t("btn-save")}</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr className="my-5" />

                        <div className="row">
                            <div className="col-lg-4 mb-3 mb-lg-0">
                                <h4>{t("platform.payments.enabled.payments")}</h4>
                                <p>{t("platform.payments.enabled.payments-p")}</p>
                            </div>
                            <div className="col-lg-8">
                                <div className="row mb-5">
                                    <div className="col-12">
                                        <div className="card">

                                            <div className="card-body">
                                                <div className="list-group list-group-lg list-group-flush list-group-no-gutters">

                                                    <div className="list-group-item">
                                                        <div className="d-flex">
                                                            <div className="flex-grow-1 ms-3">
                                                                <div className="row align-items-center">
                                                                    <div className="col">
                                                                        <img style={{ height: '25px' }} src="https://v3.ws-voices.com.mx/assets/img/openpay-logo.png" alt="Image Description" />
                                                                        <div className="mt-2">
                                                                            { !settings?.openpay &&  <span className="badge bg-soft-danger text-danger">{t("platform.payments.enabled.no-config")}</span> }
                                                                            { settings?.openpay && settings?.payment_method_active === 'openpay' &&  <span className="badge bg-soft-primary  text-primary">{t("platform.payments.enabled.default-payment")}</span> }
                                                                            { settings?.openpay && settings?.payment_method_active !== 'openpay' &&  <span className="badge bg-warning text-dark">{t("platform.payments.enabled.inactive-payment")}</span> }
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-auto">
                                                                        <div className="d-flex align-items-center">
                                                                            <button type="button" className="btn btn-white btn-sm " disabled={hasActionAccess ? false : true} onClick={() => setShowModalOpenPay(true)}><i className="bi bi-gear-fill"></i> {t("platform.payments.enabled.config-btn")}</button>
                                                                        </div>
                                                                    </div>

                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="list-group-item">
                                                        <div className="d-flex">
                                                            <div className="flex-grow-1 ms-3">
                                                                <div className="row align-items-center">
                                                                    <div className="col">
                                                                        <img style={{ height: '25px' }} src="https://v3.ws-voices.com.mx/assets/img/paypal-logo.png" alt="Image Description" />
                                                                        <div className="mt-2">
                                                                            { !settings?.paypal &&  <span className="badge bg-soft-danger text-danger">{t("platform.payments.enabled.no-config")}</span> }
                                                                            { settings?.paypal && settings?.payment_method_active === 'paypal' &&  <span className="badge bg-soft-primary  text-primary">{t("platform.payments.enabled.default-payment")}</span> }
                                                                            { settings?.paypal && settings?.payment_method_active !== 'paypal' &&  <span className="badge bg-warning text-dark">{t("platform.payments.enabled.inactive-payment")}</span> }
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-auto">
                                                                        <div className="d-flex align-items-center">
                                                                            <button type="button" className="btn btn-white btn-sm " disabled={hasActionAccess ? false : true} onClick={() => setShowModalPayPal(true)}><i className="bi bi-gear-fill"></i> {t("platform.payments.enabled.config-btn")}</button>
                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="list-group-item">
                                                        <div className="d-flex">
                                                            <div className="flex-grow-1 ms-3">
                                                                <div className="row align-items-center">
                                                                    <div className="col">
                                                                        <img style={{ height: '25px' }} src="https://v3.ws-voices.com.mx/assets/img/logo_conekta_color.svg" alt="Image Description" />
                                                                        <div className="mt-2">
                                                                            { !settings?.conekta &&  <span className="badge bg-soft-danger text-danger">{t("platform.payments.enabled.no-config")}</span> }
                                                                            { settings?.conekta && settings?.payment_method_active === 'conekta' &&  <span className="badge bg-soft-primary  text-primary">{t("platform.payments.enabled.default-payment")}</span> }
                                                                            { settings?.conekta && settings?.payment_method_active !== 'conekta' &&  <span className="badge bg-warning text-dark">{t("platform.payments.enabled.inactive-payment")}</span> }
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-auto">
                                                                        <div className="d-flex align-items-center">
                                                                            <button type="button" className="btn btn-white btn-sm " disabled={hasActionAccess ? false : true} onClick={() => setShowModalConekta(true)}><i className="bi bi-gear-fill"></i> {t("platform.payments.enabled.config-btn")}</button>
                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </IfThen>
                    </>
                    }
                    </div>
                </div>
                <Footer />
            </main>


            <OpenPayModal show={showModalOpenPay} data={settings?.openpay} is_active={settings?.payment_method_active === 'openpay'} onRequestClose={(reload) => handleCloseModal(reload, () => setShowModalOpenPay(false)) } />
            <PayPalModal show={showModalPayPal} data={settings?.paypal} is_active={settings?.payment_method_active === 'paypal'} onRequestClose={(reload) => handleCloseModal(reload, () => setShowModalPayPal(false)) } />
            <ConektaModal show={showModalConekta} data={settings?.conekta} is_active={settings?.payment_method_active === 'conekta'} onRequestClose={(reload) => handleCloseModal(reload, () => setShowModalConekta(false)) } />

        </>
    )
}